import { useContext, useState } from "react";
import UiContext from "../../../../../store/ui-context";
import useAPIRequest from "../../../../../custom_hooks/simple/useAPIRequest";

export const useAPIEditOfferRewardDiscount = (props) => {
  const { onConfirmed } = props;

  const uiContext = useContext(UiContext);
  const { requestGetOne, requestPost, loading } = useAPIRequest();

  const [data, setData] = useState({});
  const [error, setError] = useState({});

  //  API call section

  const fetchData = async ({ id, extraData }) => {
    return requestGetOne({
      fullUrl: `/api/customer/customerdiscount/one/${id}`,
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        const newData = reformatDataAfterFetch(_data);
        if (extraData) {
          setData({ ...extraData, ...newData });
        } else {
          setData(newData);
        }
      },
    });
  };

  const saveData = async () => {
    setError({});

    return requestPost({
      fullUrl: `/api/customer/customerdiscount/save`,
      body: reformatDataBeforeSave(data),
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        uiContext.showSuccessMsg("Success", message);
        const newData = reformatDataAfterFetch(_data);
        onConfirmed(newData);
      },
    });
  };

  // other function section

  const validate = () => {
    let valid = true;
    let newError = {};

    if (!data.customer_id) {
      valid = false;
      newError = { ...newError, customer_id: "Customer harus isi" };
    }

    if (!data.name || data.name.trim() === "") {
      valid = false;
      newError = { ...newError, name: "Discount nama harus isi" };
    }

    if (!data.expired_date || data.expired_date.trim() === "") {
      valid = false;
      newError = { ...newError, expired_date: "Expired date harus isi" };
    }

    if (!data.value || data.value < 0) {
      valid = false;
      newError = { ...newError, value: "Value harus isi" };
    }

    if (!data.type) {
      valid = false;
      newError = { ...newError, type: "Type harus dipilih" };
    }

    if (data.type === 2 && (data.value < 0 || data.value > 100)) {
      valid = false;
      newError = { ...newError, value: "Value must be between 0 and 100" };
    }

    setError(newError);
    return valid;
  };

  const reformatDataBeforeSave = (_data) => {
    const newData = data;

    return newData;
  };

  const reformatDataAfterFetch = (_data) => {
    return _data;
  };

  const fetchDataOrCreateNew = ({ id, extraData }) => {
    if (id && id > 0) {
      fetchData({ id, extraData });
    } else {
      if (extraData) {
        setData({ ...generateNewData(), ...extraData });
      } else {
        setData(generateNewData());
      }
    }
  };

  const generateNewData = () => {
    return {
      // PART FIELDS
      provinsi_id: '',
      kode: '',
      nama: '',
    };
  };

  // handle ui event section

  const handleOnConfirm = () => {
    const valid = validate();
    if (valid) {
      saveData();
    }
  };

  return {
    loading,
    data,
    setData,
    error,
    setError,
    fetchDataOrCreateNew,
    handleOnConfirm,
    onConfirmed,
  };
};
